// Browser APIs the app and its bundled packages assume. main.tsx imports this
// first: imports evaluate in order, and @neuro/chat-adapter already calls
// crypto.randomUUID() while App's imports load.
import { installRandomUUIDPolyfill } from './utils/randomUUID';

installRandomUUIDPolyfill();
